// extracted by mini-css-extract-plugin
module.exports = {"bargain-data":"_3fOj7lrmWS","table-title":"_3f2Rwrmm7R","header":"_2gWUdPHxRD","form-item":"_23xGfy0wRa"};